import api from "@/api";

import deepClone from "@/utils/deep-clone";

const state = {
    list: [],
    details: {},
};

const getters = {
    list(state) {
        return () => deepClone(state.list);
    },
    details(state) {
        return id => deepClone(state.details[id]);
    },
};

const actions = {
    getList({ commit }) {
        return api.get(`/api/notifications/get/feedbackRequest/all`).then(res => {
            const list = res.data;

            commit("updateList", { list });
        });
    },
    get({ commit }, { payload: { senderId } }) {
        // FIXME: The API endpoint uses the sender of a feedback request as the unique identifier,
        // as such, we need to use it as our key in the store as well.
        //
        // Ideally, we should take the request ID as unique identifier.
        //
        return api.get(`/api/notifications/get/feedbackRequest/${senderId}`).then(res => {
            const request = res.data[0];

            commit("updateDetails", { request });
        });
    },
    send(_, { payload: { receivers, message, skills = [] } }) {
        const data = {
            receivers,
            type: "feedbackRequest",
            parameters: {
                requestQuestion: message,
                requestSkills: skills,
            },
        };

        return api.post(`/api/notifications/create`, data);
    },
    dismiss({ dispatch }, { payload: { id } }) {
        return api
            .post(`/api/notifications/update`, {
                _id: id,
                isDismissed: true,
                isDone: false,
            })
            .then(() => dispatch("getList"));
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = list;
    },
    updateDetails(state, { request }) {
        // FIXME: The API endpoint uses the sender of a feedback request as the unique identifier,
        // as such, we need to use it as our key in the store as well.
        //
        // Ideally, we should take the request ID as unique identifier.
        //
        const key = request.sender.user._id;

        state.details[key] = request;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
